/**
 * Magnetic buttons — an element leans toward the cursor, then releases.
 *
 * Lifted out of ElfHero so every hero variant can use the same behaviour.
 * Pointer-driven and decorative: touch never fires it, and nothing depends on
 * it having run.
 */

import React, { useCallback } from 'react';

export function useMagnetic() {
  const onPointerMove = useCallback((e: React.PointerEvent<HTMLElement>) => {
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `translate(${px * 12}px, ${py * 7}px) scale(1.04)`;
  }, []);

  const onPointerLeave = useCallback((e: React.PointerEvent<HTMLElement>) => {
    e.currentTarget.style.transform = '';
  }, []);

  return { onPointerMove, onPointerLeave };
}

export default useMagnetic;
